// extracted by mini-css-extract-plugin
export default {"cadreError":"Error_cadreError__DztNC","leCadre":"Error_leCadre__yHega","title":"Error_title__5EkbD","texteError":"Error_texteError__JKjo5","lien":"Error_lien__FkMjd"};